var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
let Captcha = (() => {
    let _classDecorators = [observer];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = React.Component;
    var Captcha = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            Object.defineProperty(this, "recaptchaRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: React.createRef()
            });
            Object.defineProperty(this, "getCaptchaAsync", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: async () => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                    if ((_a = this.state) === null || _a === void 0 ? void 0 : _a.captcha) {
                        return this.state.captcha;
                    }
                    if (this.props.propStateStore.env === 'ui-test') {
                        return '';
                    }
                    if ((_c = (_b = this.recaptchaRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.getValue()) {
                        const token = (_e = (_d = this.recaptchaRef) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.getValue();
                        this.setState({ captcha: token });
                        return token;
                    }
                    try {
                        const token = await ((_g = (_f = this.recaptchaRef) === null || _f === void 0 ? void 0 : _f.current) === null || _g === void 0 ? void 0 : _g.executeAsync());
                        this.setState({ captcha: token });
                        return token;
                    }
                    catch (e) {
                        console.error(e);
                        (_j = (_h = this.recaptchaRef) === null || _h === void 0 ? void 0 : _h.current) === null || _j === void 0 ? void 0 : _j.execute();
                        const token = (_l = (_k = this.recaptchaRef) === null || _k === void 0 ? void 0 : _k.current) === null || _l === void 0 ? void 0 : _l.getValue();
                        this.setState({ captcha: token });
                        return token;
                    }
                }
            });
            Object.defineProperty(this, "onChange", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (str) => {
                    this.setState({ captcha: str });
                }
            });
            Object.defineProperty(this, "onError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    this.setState({ captcha: '' });
                }
            });
            Object.defineProperty(this, "onExpire", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    this.setState({ captcha: '' });
                }
            });
        }
        componentDidMount() {
            if (!document.getElementById('captchaStyle')) {
                const styleElement = document.createElement('style');
                styleElement.id = 'captchaStyle';
                document.getElementsByTagName('head')[0].appendChild(styleElement);
            }
            document.getElementById('captchaStyle').innerText = '.grecaptcha-badge {width: 0 !important;height: 0 !important;}';
            setTimeout(() => {
                document.querySelectorAll('iframe').forEach((iframe) => {
                    if (iframe.title === 'reCAPTCHA') {
                        iframe.setAttribute('tabindex', '-1');
                    }
                });
            }, 500);
        }
        render() {
            const { currentLanguage } = this.props;
            return (React.createElement(ReCAPTCHA, { ref: this.recaptchaRef, onErrored: this.onError, onChange: this.onChange, onExpired: this.onExpire, hl: currentLanguage, size: "invisible", sitekey: "6LdY4dEpAAAAAKX9qFoYShRz95Ca2S5fT6mK9zKt", "aria-hidden": true }));
        }
    };
    __setFunctionName(_classThis, "Captcha");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        Captcha = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return Captcha = _classThis;
})();
export default inject('propStateStore')(Captcha);
//# sourceMappingURL=Captcha.js.map